<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ customer.phone }} {{ customer.firstname }} {{ customer.lastname }}</strong>
                </CCardHeader>
                <CCardBody>
                    <div v-if="loading" class="text-center">
                        <CSpinner color="primary" />
                    </div>
                    <div v-else>
                        <CustomerTabLinks />
                        <CRow class="pl-3 pb-3" />
                        <CForm>
                            <CRow>
                                <CCol sm="6">
                                    <div class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                        <!-- <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>ID пользователя</b></CCol>
                                            <CCol sm="6" class="col-form-label">{{ customer.id }}</CCol>
                                        </CRow> -->
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Имя и фамилия</b></CCol>
                                            <CCol sm="3" class="col-form-label">
                                                <CInput class="mb-0" v-model="customer.firstname" />
                                            </CCol>
                                            <CCol sm="3" class="col-form-label">
                                                <CInput class="mb-0" v-model="customer.lastname" />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Дата рождения</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <DatePicker
                                                    v-model="customer.birthday"
                                                    :language="datepicker.lang"
                                                    :format="datepicker.format"
                                                    input-class="form-control custom-datepicker" />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Пол</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSelect
                                                    class="mb-0"
                                                    horizontal
                                                    :options="genderOptions"
                                                    :value.sync="customer.gender"
                                                    placeholder="Пол..."
                                                />
                                            </CCol>
                                        </CRow>
                                        <!-- <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Телефон</b></CCol>
                                            <CCol sm="6" class="col-form-label"><CInput
                                                class="mb-0"
                                                v-model="customer.phone"
                                                disabled
                                            /></CCol>
                                        </CRow> -->
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Email</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CInput class="mb-0" v-model="customer.email" />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Предпочтительный способ связи</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSelect
                                                    class="mb-0"
                                                    horizontal
                                                    :options="communicationMethodOptions"
                                                    :value.sync="customer.preferred_communication_method"
                                                    placeholder="Выберите способ связи..."
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Активен</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="customer.enabled"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Подтвержден 18+</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="customer.adult"
                                                />
                                            </CCol>
                                        </CRow>
                                        <!-- <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Дата регистрации</b></CCol>
                                            <CCol sm="6" class="col-form-label">{{ formatDate(customer.created_at) }}</CCol>
                                        </CRow> -->
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Источник регистрации</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CInput class="mb-0" v-model="customer.registration_source" />
                                            </CCol>
                                        </CRow>
                                        <CRow form>
                                            <CCol sm="6" class="col-form-label"><b>Предпочтительный язык</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CInput class="mb-0" v-model="customer.language" />
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCol>
                                <CCol sm="6">
                                    <div class="px-4 py-2 border border-gray-300 rounded-md">
                                        <CRow form>
                                            <CCol sm="12" class="col-form-label"><b>Статус локации (башня)</b></CCol>
                                            <CCol sm="6" class="col-form-label">
                                                Живет в Москва-Сити
                                            </CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="customer.location_status.living"
                                                />
                                            </CCol>
                                            <template v-if="customer.location_status.living">
                                                <CCol sm="6" class="col-form-label">
                                                    Номер апартаментов
                                                </CCol>
                                                <CCol sm="6" class="col-form-label">
                                                    <CInput class="mb-0" v-model="customer.location_status.appartment" />
                                                </CCol>
                                            </template>
                                            <CCol sm="6" class="col-form-label">
                                                Работает в Москва-Сити
                                            </CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="customer.location_status.working"
                                                />
                                            </CCol>
                                            <template v-if="customer.location_status.working">
                                                <CCol sm="6" class="col-form-label">
                                                    Название компании
                                                </CCol>
                                                <CCol sm="6" class="col-form-label">
                                                    <CInput class="mb-0" v-model="customer.location_status.company" />
                                                </CCol>
                                            </template>
                                            <CCol sm="6" class="col-form-label">
                                                Часто бывает в Москва-Сити
                                            </CCol>
                                            <CCol sm="6" class="col-form-label">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="customer.location_status.sometimes"
                                                />
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCol>
                                <CCol sm="12" v-if="adminOnly">
                                    <div class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                        <CRow form>
                                            <CCol sm="3" class="col-form-label"><b>Комментарий о клиенте</b></CCol>
                                            <CCol sm="9" class="col-form-label">
                                                <CInput
                                                    v-model="customer.description" />
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCol>
                            </CRow>
                        </CForm>
                    </div>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true">Удалить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить клиента? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteCustomer">Удалить</CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import CustomerTabLinks from '@/components/CustomerTabLinks';

    export default {
        name: 'CustomerEdit',

        components:{
            CustomerTabLinks,
            DatePicker,
        },

        data() {
            return {
                loading: true,
                customer: {
                    id: 0,
                    phone: '',
                    firstname: '',
                    lastname: '',
                    description: '',
                    adult: false,
                    gender: 0,
                    confirmed: false,
                    enabled: false,
                    location_status: {},
                    preferred_communication_method: null,
                    activity_status: null
                },
                genderOptions: [
                    {
                        value: 0,
                        label: 'Не выбрано'
                    },
                    {
                        value: 1,
                        label: 'Мужской'
                    },
                    {
                        value: 2,
                        label: 'Женский'
                    },
                ],
                communicationMethodOptions: [
                    {
                        value: null,
                        label: 'Не выбрано'
                    },
                    {
                        value: 'PUSH',
                        label: 'Push-уведомления'
                    },
                    {
                        value: 'EMAIL',
                        label: 'Email'
                    },
                    {
                        value: 'WHATSAPP',
                        label: 'WhatsApp'
                    },
                    {
                        value: 'TELEGRAM',
                        label: 'Telegram'
                    },
                ],
                deleteModal: false,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                },
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/customers/get/' + id)
                .then(resp => {
                    this.customer = resp.data;
                    if(!this.customer.location_status) {
                        this.customer.location_status = {
                            living: false,
                            appartment: '',
                            working: false,
                            company: '',
                            sometimes: false
                        }
                    }
                    this.loading = false;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    this.loading = false;
                });
        },

        methods: {
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY');
            },
            formattedCustomerStatus(status) {
                switch (status) {
                case 1:
                    return { text: 'Золото', style: 'color: #FFD700' };
                case 2:
                    return { text: 'Серебро', style: 'color: #C0C0C0' };
                default:
                    return { text: 'Нейтральный', style: '' };
                }
            },
            save() {
                Vue.axios
                    .post('/customers/update/' + this.customer.id, this.customer)
                    .then(rest => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохраниения.');
                    });
            },
            deleteCustomer() {
                Vue.axios
                    .post('/customers/delete/' + this.customer.id)
                    .then(resp => {
                        this.$router.push({ path: '/customers' });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },
            goBack() {
                this.$router.push({ path: '/customers/' + this.customer.id });
            },
        },
    };
</script>
<style>
.custom-datepicker.form-control:disabled, .custom-datepicker.form-control[readonly] {
    background-color: #ffffff;
}
</style>
